<template>
  <div class="confidence-card">
    <div class="high" v-if="score >= 90">
      <i
        class="fa fa-thumbs-o-up"
        title="High Confidence"
        aria-hidden="true"
      ></i>
      <span class="pl-5px"> {{ score }}% </span>
    </div>
    <div class="medium" v-if="score < 90 && score >= 80">
      <i
        class="fa fa-thumbs-o-up"
        title="Medium Confidence"
        aria-hidden="true"
      ></i>
      <span class="pl-5px"> {{ score }}% </span>
    </div>
    <div class="low" v-if="score < 80">
      <i
        class="fa fa-thumbs-o-up"
        title="Low Confidence"
        aria-hidden="true"
      ></i>
      <span class="pl-5px"> {{ score }}% </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneCard',
  props: ['score']
}
</script>

<style scoped lang="scss">
.confidence-card {
  display: flex;
  i {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  .high {
    color: $green;
    i {
      border: 1px solid $green;
    }
  }
  .medium,
  .low,
  .high {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .medium {
    color: $orange;
    i {
      border: 1px solid $orange;
    }
  }
  .low {
    color: $sandal-yellow;
    i {
      border: 1px solid $sandal-yellow;
    }
  }
}
</style>
